import {mainQuery} from '@github-ui/react-core/future/main-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {OverviewRoutePayload} from './route-payload-types'
import type {FindingsPayload} from '@github-ui/copilot-code-review-findings/types'
import type {ReviewRequestsData} from '../page-data/payloads/review-requests'
import {pageDataQuery} from './page-data-query'

export const pullRequestsOverviewRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsOverviewRoute', {
  path: '/:owner/:repo/pull/:pr_number/overview',
  queries: [
    mainQuery<OverviewRoutePayload>(),
    pageDataQuery<ReviewRequestsData, 'review_requests'>('review_requests'),
    pageDataQuery<FindingsPayload, 'findings'>('findings'),
  ],
})
